<template>
  <div>
    <!-- 规格选择部分 -->
    <!-- 多规格样式 -->
    <div class="paddingtb border">
      <div v-for="(spec,specName) in sepcOptions" :key="specName">
        {{specName}}
        <div :class="[spec[0].main_image===1?'':'spec-container']">
          <div
            :class="['spec_item',option.main_image===1?'':'margin-right',option.is_selected?'sel_red':'',option.is_stock?'':'' ]"
            v-for="option in spec" :key="option.id" @click="selectedSpec(option)">
            <img v-if="option.spec_pic" :src="option.spec_pic" />
            <div :class="option.main_image===1?'margin-left':'padding-sm'">{{option.value}}</div>
            <div class="wu_huo" v-if="!option.is_stock">无货</div>
          </div>
        </div>
      </div>

    </div>

    <!-- 显示选中规格的信息 -->
    <!-- <div v-if="selectedSpecification">
      <img :src="selectedSpecification.image" alt="规格图" />
      <p>价格: {{ selectedSpecification.price }} 元</p>
      <p>规格: {{ selectedSpecification.spec_value_str }}</p>
    </div> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        specifications: [{
            id: 28,
            image: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/202408291601492edb26741.jpg",
            goods_id: 10012,
            spec_value_ids: "291,299",
            spec_value_str: "颜色:荧光绿,鞋码:40",
            price: "298.00",
          },
          {
            id: 32,
            image: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/202408291601492edb26741.jpg",
            goods_id: 10012,
            spec_value_ids: "291,295",
            spec_value_str: "颜色:荧光绿,鞋码:36",
            price: "298.00",
          },
          {
            id: 29,
            image: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/20240829160149d9d4b0932.jpg",
            goods_id: 10012,
            spec_value_ids: "293,298",
            spec_value_str: "颜色:天蓝色,鞋码:39",
            price: "298.00",
          },
          {
            id: 30,
            image: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/20240829160149fd6f00135.jpg",
            goods_id: 10012,
            spec_value_ids: "294,300",
            spec_value_str: "颜色:龙橙虎跃,鞋码:41",
            price: "300.00",
          },
          {
            id: 31,
            image: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/20240829160149eab399763.jpg",
            goods_id: 10012,
            spec_value_ids: "292,296",
            spec_value_str: "颜色:白色,鞋码:37",
            price: "278.00",
          },
        ],
        allSpecs: [{
            id: 291,
            spec_id: 95,
            value: "荧光绿",
            spec_pic: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/202408291601492edb26741.jpg",
            spec_name: "颜色",
            main_image: 1
          },
          {
            id: 292,
            spec_id: 95,
            value: "白色",
            spec_pic: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/20240829160149eab399763.jpg",
            spec_name: "颜色",
            main_image: 1
          },
          {
            id: 293,
            spec_id: 95,
            value: "天蓝色",
            spec_pic: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/20240829160149d9d4b0932.jpg",
            spec_name: "颜色",
            main_image: 1
          },
          {
            id: 294,
            spec_id: 95,
            value: "龙橙虎跃",
            spec_pic: "http://jp-wailian.oss-cn-beijing.aliyuncs.com/uploads/images/20240829/20240829160149fd6f00135.jpg",
            spec_name: "颜色",
            main_image: 1
          },
          {
            id: 295,
            spec_id: 96,
            value: "36",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 296,
            spec_id: 96,
            value: "37",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 297,
            spec_id: 96,
            value: "38",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 298,
            spec_id: 96,
            value: "39",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 299,
            spec_id: 96,
            value: "40",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 300,
            spec_id: 96,
            value: "41",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 301,
            spec_id: 96,
            value: "42",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 302,
            spec_id: 96,
            value: "43",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 303,
            spec_id: 96,
            value: "44",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 304,
            spec_id: 96,
            value: "45",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
          {
            id: 305,
            spec_id: 96,
            value: "46",
            spec_pic: "",
            spec_name: "鞋码",
            main_image: 0
          },
        ],
        selectedColor: null,
        selectedSize: null,
        select_spec: [], //选中的规格id数组
        stockList: [],
        old_spec: null,
        new_spec: null,
        selectedSpecification:null
      };
    },
    created() {
      this.firstSpec()
    },
    computed: {
      sepcOptions() {
        // 解析规格数据
        let newSpec = []
        return newSpec = this.allSpecs.reduce((acc, spec) => {
          if (!acc[spec.spec_name]) {
            acc[spec.spec_name] = [];
          }
          acc[spec.spec_name].push(spec);
          acc[spec.spec_name].sort((a, b) => b.main_image - a.main_image);

          return acc;
        }, {});
      },
      // colorOptions() {
      //   return this.allSpecs.filter((spec) => spec.spec_name === "颜色");
      // },
      // sizeOptions() {
      //   return this.allSpecs.filter((spec) => spec.spec_name === "鞋码");
      // },
      // // 获取当前选中颜色下可用的鞋码ID
      // availableSizes() {
      //   if (this.selectedColor) {
      //     return this.specifications
      //       .filter((spec) => spec.spec_value_ids.includes(this.selectedColor))
      //       .flatMap((spec) => spec.spec_value_ids.split(","))
      //       .map(Number);
      //   }
      //   return [];
      // },
      // selectedSpecification() {
      //   if (this.selectedColor && this.selectedSize) {
      //     return this.specifications.find(
      //       (spec) =>
      //       spec.spec_value_ids.includes(this.selectedColor) &&
      //       spec.spec_value_ids.includes(this.selectedSize)
      //     );
      //   }
      //   return null;
      // }
    },
    methods: {
      //首次赋值
      firstSpec() {

        let selGoods = this.specifications[0].spec_value_ids.split(',')
        this.select_spec = selGoods;
        this.updateSpec()
      },
      //更新选中与有货无货
      updateSpec() {

        this.allSpecs = this.allSpecs.map(ps => ({
          ...ps,
          is_stock: false,
          is_selected: false
        }))

        const specValueIds = this.specifications.flatMap(spec => spec.spec_value_ids.split(',').map(Number));

        const filteredAllSpecs = this.allSpecs.filter(spec => specValueIds.includes(spec.id) && spec.main_image === 1);

        filteredAllSpecs.forEach(item=>{
          item.is_stock = true;
        })

        let wddd = this.specifications
          .filter((spec) => spec.spec_value_ids.includes(this.select_spec[0]))
        const specValueIdsSet = new Set();

        // 遍历 stockList，提取 spec_value_ids 字段
        wddd.forEach(item => {
          const ids = item.spec_value_ids.split(","); // 分割字符串为数组
          ids.forEach(id => specValueIdsSet.add(id)); // 将每个 ID 添加到 Set 中
        });
        // 将 Set 转换为数组并赋值给 uniqueSpecValueIds
        let uniqueSpecValueIds = Array.from(specValueIdsSet);
        //将已知的数组
        const extraSet = new Set(this.select_spec)
        let abc = uniqueSpecValueIds.filter(id => !extraSet.has(id));
        const specMap = this.allSpecs.reduce((map, item) => {
          map[item.id] = item;
          return map;
        }, {});
        //选中的规格遍历附加样式
        this.select_spec.forEach(id => {
          if (specMap[id]) {
            const result = uniqueSpecValueIds.includes(id);
            if (result) {
              specMap[id].is_selected = true;
              specMap[id].is_stock = true;
            } else {
              specMap[id].is_selected = true;
            }

          }
        });
        //添加有货样式
        abc.forEach(id => {
          if (specMap[id]) {
            specMap[id].is_stock = true;
          }
        });


        this.productSelection()
      },
      //选中
      selectedSpec(spec) {
        const existingIndex = this.select_spec.findIndex(id => {
          const existingItem = this.allSpecs.find(obj => obj.id === Number(id));
          return existingItem && existingItem.spec_name === spec.spec_name;
        });

        if (spec.main_image == 1) {
          // 如果选中的对象是主要的，则只保留当前选中的ID
          this.select_spec = [String(spec.id)];
        } else if (existingIndex !== -1) {
          // 如果类型相同，替换原来的ID
          this.select_spec.splice(existingIndex, 1, String(spec.id));
        } else {
          // 如果没有相同类型，直接添加ID
          this.select_spec.push(String(spec.id));
        }
        this.updateSpec()
      },
      //商品选中
      productSelection(){
        let find_spec = this.specifications.find(
          (spec) =>
          spec.spec_value_ids.includes(this.select_spec.join(','))
        );
        let spec_size = Object.keys(this.sepcOptions).length
        console.log(this.select_spec.length,"wwwww")
        if(this.select_spec.length === spec_size){
          if(find_spec){
            this.selectedSpecification = find_spec
          }else{
            alert('请选择有货的商品')
          }
        }
      },
      selectColor(colorId) {
        // this.selectedColor = colorId;
        // this.selectedSize = null; // 重置鞋码选择

      },
      selectSize(sizeId) {
        if (this.isSizeAvailable(sizeId)) {
          this.selectedSize = sizeId;
        }
      },
      // 检查鞋码是否可用
      isSizeAvailable(sizeId) {
        return this.availableSizes.includes(sizeId);
      },
    },
  };
</script>

<style scoped>
  .selected {
    background-color: #4caf50;
    color: white;
  }

  .disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }

  .spec_item {
    position: relative;
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    margin-top: 10px;
  }

  .spec_item img {
    width: 50px;
  }

  .spec-container {
    display: flex;
    flex-wrap: wrap;
  }

  .margin-right {
    margin-right: 10px;
  }

  .margin-left {
    margin-left: 10px;
  }

  .padding-sm {
    padding: 5px 10px;
  }

  .paddingtb {
    padding: 20px;
  }

  .sel_red {
    border: 1px solid red;
    color: red;
  }

  .stock {
    border: 1px solid;
  }

  .wu_huo {
    position: absolute;
    font-size: 10px;
    top: -8px;
    right: -12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/getUa.vue